// Build a safe onsubmit confirm() attribute (MT-051): JSON.stringify makes the
// message a valid JS string literal (quotes in record names included), and the
// handler is then entity-escaped for the HTML-attribute context.
function confirmSubmitAttr(message) {
    var js = 'return confirm(' + JSON.stringify(String(message)) + ');';
    return 'onsubmit="' + js.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '"';
}

import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}

 function percentage(partialValue, totalValue) {
  if(partialValue == 0) { return 0; }
  return parseFloat((100 * partialValue) / totalValue).toFixed(2);
} 

document.addEventListener('DOMContentLoaded', function() {
/** 
   * Generic user datatable configuration for properties table /properties
   */
  if(document.getElementsByClassName('hfs-data-property-table').length > 0){

    

    if(document.getElementsByClassName('hfs-data-property-table')[0].dataset.archive){
      
        var archive = true;
        var archiveStr = '?archive=true';
        var columns = [
            { 
            data: 'name',
            render: function(data, type, row) {
                return propertyName(data, type, row);
            },
            className: 'align-middle'
            },
            { 
            data: 'actions', 
            render: function(data, type, row){
                return propertyArchiveButtons(data, type, row);
            },
            className: 'align-middle text-end'
            },
        ];

    }else{

        var archive = false;
        var archiveStr = '';

        var columns = [
        { 
            data: 'name',
            render: function(data, type, row) {
            return propertyName(data, type, row);
            },
            className: 'align-middle'
        },
        { 
          data: 'theme',
          className: 'align-middle',
          width: 200
          },
        { 
            data: 'city',
            className: 'align-middle',
            width: 150
        },
        { 
          data: 'location',
          className: 'align-middle',
          width: 100
        },
        {
          data: 'client',
          className: 'align-middle',
          width: 100
        },
        {
          data: 'residentsCount',
          className: 'align-middle',
          width: 200,
          render: function(data, type, row){
            // var percent = percentage(data, row.residents);
            return data+' active in 24 hours <small class="d-block">'+row.residents+' residents</small>';
          },
        },
        { 
            data: 'enabled', 
            render: function(a,b,c){
            return propertyEnabled(a,b,c);
            },
            className: 'align-middle',
            width: 80
        },
        { 
            data: 'actions', 
            render: function(data, type, row){
            return propertyButtons(data, type, row);
            },
            className: 'align-middle text-end',
            width: 360
        },
        ];

    }

    function propertyButtons(data, display, row){
    
      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      var btnHTML = `
      <div class="btn-group">
        <a href="/properties/`+row.id+`" class="btn btn-outline-secondary btn-sm" title="Show property">
          <i class="fa fa-eye fa-fw"></i> Show
        </a>
        <a href="/properties/`+row.id+`/edit" class="btn btn-outline-secondary btn-sm" title="Edit property">
          <i class="fa fa-pencil fa-fw"></i> Edit
        </a>`;

      // ui hide, actual method is restricted server side.
      if($('#hidden_user_level_id').val() == 1 ||  $('#hidden_user_level_id').val() == 2){
        btnHTML += `
          <form method="POST" action="/properties/`+row.id+`" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to archive the property ' + row.name + '?')+`>
          <input name="_method" type="hidden" value="DELETE">
          <input name="_token" type="hidden" value="`+token+`">
            <button type="submit" class="btn btn-outline-danger hfs-btn-table-delete btn-sm">
              <i class="fa fa-trash fa-fw"></i> Archive
            </button>
          </form>`;
      }

      btnHTML += `
      </div>`;
      
      return btnHTML;

    };

    function propertyArchiveButtons(data, display, row){
      
      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      var btnHTML = `
      <div class="btn-group">
        <form method="POST" action="/properties/archive/restore" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to restore the property ' + row.name + '?')+`>
        <input name="_method" value="DELETE" type="hidden" />
        <input name="restore_id" type="hidden" value="`+row.id+`">
        <input name="_token" type="hidden" value="`+token+`">

          <button type="submit" class="btn btn-outline-danger  btn-sm">
            <i class="fa-solid fa-trash-arrow-up fa-fw"></i> Restore
          </button>
        </form>
      </div>`;
      
      return btnHTML;

    };

    function propertyName(data,display,row){
     
      var propertyHTML = `
      <div class="d-flex px-2 py-1">
        <div>`;
        if(!row.image_url){
          propertyHTML += `<img class="avatar avatar-sm me-3" src="/assets/img/placeholder.webp">`;
        }else{
          propertyHTML += `<img class="avatar avatar-sm me-3" src="`+row.image_url+`">`;
        }
      propertyHTML += `
        </div>
        <div class="d-flex flex-column justify-content-center">
          <h6 class="mb-0 text-xs">`+row.name+`</h6>
          <small><i class="fa fa-location-dot"></i> `+row.city+`</small>
        </div>
      </div>`;

      return propertyHTML;
    };

    function propertyEnabled(data,b,c){

      var enabled = `
      <a href="javascript: void(0)" class="toggle-record" 
        data-table="properties" 
        data-id="`+c.id+`" 
        data-column="enabled">`;

      if(data === 1){
        enabled += '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
      }else{
        enabled += '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
      }

      enabled += `</a>`;
      return enabled;
    };

    // function propertyEnabled(data){
    //   if(data === 1){
    //     var enabled = '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
    //   }else{
    //     var enabled = '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
    //   }
    //   return enabled;
    // };

    let table = new dt('.hfs-data-property-table', {
      // processing: true,
      serverSide: true,
      lengthMenu: [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
      columns: columns,
      rowId: 'id',
      order: [[ 0, 'asc' ]],
      ajax: '/properties/ajax/json'+archiveStr,
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });

  }

  /**
   * Areas ajax (on selection of region, match areas.region_id of given region)
   */

  if( document.getElementById('region_id_selection') !== null ){

    $('#region_id_selection').on('change', function(e){

      let regionSelectedId = $(this).val();

      // get regional changed person name
      $.ajax({
        url: '/properties/ajax/regionUsersJson',
        data: {
          region_id: regionSelectedId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        method: 'GET',
        success: function(response) {

          if(response.length > 0){
            var str = ``;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              str += `<a href="/users/`+element.id+`" target="_blank">`+element.name+`</a>, `;
            }
            str = str.slice(0, -2);
            $('.regional-users-list').html(str);
            $('.regional-users-list').show();

          }else{
            // none assigned, hide info box.
            $('.regional-users-list').hide();
          }

        }
      });

      // empty current areas dropdown, to re-populate
      $('#area_id_selection').empty();

      // disable until populated
      $('#area_id_selection').prop('disabled', true);

      // append please select again...
      $('#area_id_selection').append('<option value="">Please choose...</option>')

      // perform ajax request
      $.ajax({
        url: '/properties/ajax/areasJson',
        data: {
          region_id: regionSelectedId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        method: 'GET',
        success: function(response) {

          $.each(response, function (i, item) {
              $('#area_id_selection').append($('<option>', { 
                  value: item.id,
                  text : item.name 
              }));
          });

          // re-enable
          $('#area_id_selection').prop('disabled', false);
          
        },
        error: function(error) {
          console.error('areas list error', error);
        }
      })
    });

    $('#area_id_selection').on('change', function(e){

      let areaSelectedId = $(this).val();
      // get area changed person name
      $.ajax({
        url: '/properties/ajax/areaUsersJson',
        data: {
          area_id: areaSelectedId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        method: 'GET',
        success: function(response) {

          if(response.length > 0){
            var str = ``;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              str += `<a href="/users/`+element.id+`" target="_blank">`+element.name+`</a>, `;
            }
            str = str.slice(0, -2);
            $('.area-users-list').html(str);
            $('.area-users-list').show();

          }else{
            // none assigned, hide info box.
            $('.area-users-list').hide();
          }

        }
      });

    })

    $('#client_id_selection').on('change', function(e){

      let areaSelectedId = $(this).val();
      // get area changed person name
      $.ajax({
        url: '/properties/ajax/clientUsersJson',
        data: {
          client_id: areaSelectedId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        method: 'GET',
        success: function(response) {

          if(response.length > 0){
            var str = ``;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              str += `<a href="/users/`+element.id+`" target="_blank">`+element.name+`</a>, `;
            }
            str = str.slice(0, -2);
            $('.client-users-list').html(str);
            $('.client-users-list').show();

          }else{
            // none assigned, hide info box.
            $('.client-users-list').hide();
          }

        }
      });

    })

    $('#sale_manager_id_selection').on('change', function(e){

      let smSelectedId = $(this).val();
      // get area changed person name
      $.ajax({
        url: '/properties/ajax/salesUsersJson',
        data: {
          sales_manager_id: smSelectedId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        method: 'GET',
        success: function(response) {

          if(response.length > 0){
            var str = ``;
            for (let index = 0; index < response.length; index++) {
              const element = response[index];
              str += `<a href="/users/`+element.id+`" target="_blank">`+element.name+`</a>, `;
            }
            str = str.slice(0, -2);
            $('.sales-users-list').html(str);
            $('.sales-users-list').show();

          }else{
            // none assigned, hide info box.
            $('.sales-users-list').hide();
          }

        }
      });

    })

  }

});